import { SAVE_AUTH, LOGOUT } from './action';

const saveAuth = (authData) => {
  return {
    type: SAVE_AUTH,
    data: authData
  }
}

const logout = () => {
  return {
    type: LOGOUT
  }
}

export {
  saveAuth,
  logout
}